import { useQuery } from "@tanstack/react-query";
import {
  getCompetencyGroups,
  getCompetencyGradeExpectationsByGroup,
} from "./api";

export const useCompetencyData = (grade) => {

  let dbGrade = grade;

  return useQuery({
    queryKey: ["competency-data", dbGrade],
    queryFn: async () => {
      const groups = await getCompetencyGroups();

      if (!groups || !Array.isArray(groups)) {
        return [];
      }

      const sectionsPromises = groups.map(async (group) => {
        const expectations = await getCompetencyGradeExpectationsByGroup(
          dbGrade,
          group.id
        );

        const expectationMap = new Map(
          (expectations || [])
            .filter((e) => e?.competency?.id)
            .map((e) => [e.competency.id, e.expectation])
        );

        const orderedCompetencies = Array.isArray(group.competencies)
          ? group.competencies
          : [];

        const items = orderedCompetencies
          .map((comp) => ({
            key: comp.key, // Use the snake_case key from competency table
            label: comp.title,
            description: expectationMap.get(comp.id),
            type: "rating",
          }))
          .filter((i) => Boolean(i.description));

        return {
          title: group.name || group.title,
          items,
        };
      });

      const allSections = await Promise.all(sectionsPromises);

      const validSections = allSections.filter((section) => section !== null);

      return validSections;
    },
    enabled: !!dbGrade,
  });
};
